function useHRReportTool() {
  function saveReportLocal(data) {
    localStorage.setItem("generated-hr-report", JSON.stringify(data));
    alert("Generated Report Successfully Saved Locally!")
  }
  return { saveReportLocal };
}

export default useHRReportTool;
